export default __webpack_public_path__ + "static/feature16banner-0d1aae28492edc9bcda51de7535fbbec.svg";